module.exports = __webpack_public_path__ + "static/assets/a2226d04601d7cfc002524cf07c01297.png";